import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Modals from '../../../../shared/types/enums/modals';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import { store } from '../../../../shared/store/store';

const getModalStyle = () => {
  const { modal } = store.getState();
  switch (modal.current) {
    case Modals.PARENTAL_PIN_GENERIC:
      return {
        'line-height': `${60 * Screen.widthRatio}px`,
        bottom: `${150 * Screen.widthRatio}px`,
        width: `${1454 * Screen.widthRatio}px`,
      };
    case Modals.PARENTAL_PIN_ZAPPER:
      return {
        'line-height': `${60 * Screen.widthRatio}px`,
        bottom: `${96 * Screen.widthRatio}px`,
        width: `${1454 * Screen.widthRatio}px`,
      };
  }
  return '';
};

const ModalExtraTitle = styled.span<React.CSSProperties>`
  color: ${Colors['light']};
  font-family: ${Fonts['regular']};
  font-size: ${36 * Screen.widthRatio}px;
  height: fit-content;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  text-align: center;
  width: fit-content;
  ${() => {
    return getModalStyle();
  }}
`;

export default ModalExtraTitle;
